<template>
    <div class="box-icon box-icon--effect details-controllers-margin">
      <i :class="`d-flex bx bx-${speechIcon} ${colorClass}`" @click="onClick" type='solid'></i>
    </div>
</template>

<script>
export default {
  name: 'TextToSpeech',

  props: ['speech', 'label'],

  data() {
    return {
      speechIcon: 'volume-mute',
      colorClass: 'color-dumb',
      textToSpeech: false,
      spokenText: this.speech || '',
    };
  },

  mounted() {
    if (this.label === 'help') {
      this.$root.$on('textToSpeechHelp', this.onClick);
    } else if (this.label === 'exploreDescription') {
      this.$root.$on('textToSpeechInformation', this.onClick);
    } else {
      this.$root.$on('textToSpeechDetails', this.onClick);
    }
  },

  beforeDestroy() {
    if (this.label === 'help') {
      this.$root.$off('textToSpeechHelp');
    } else if (this.label === 'exploreDescription') {
      this.$root.$off('textToSpeechInformation');
    } else {
      this.$root.$off('textToSpeechDetails');
    }
  },

  methods: {
    onSpeech() {
      if (!this.textToSpeech) {
        const splitter = (str) => {
          const strs = [];
          let temp = str;
          while (temp.length > 200) {
            const newStr = temp.substring(0, 200);
            temp = temp.substring(200, temp.length);
            strs.push(newStr);
          }
          strs.push(temp);
          return strs;
        };
        const speech = this.$store.state.text_to_speech;
        const splits = splitter(speech);
        splits.map((sp) => {
          const msg = new SpeechSynthesisUtterance(sp);
          console.log('SPEAK', msg);
          window.speechSynthesis.speak(msg);
          return sp;
        });
      } else {
        window.speechSynthesis.cancel();
      }
    },

    onClick() {
      this.speechIcon = this.speechIcon === 'volume-full' ? 'volume-mute' : 'volume-full';
      this.colorClass = this.colorClass === 'box-icon--active' ? 'color-dumb' : 'box-icon--active';
      if (!this.textToSpeech) {
        this.$store.dispatch('setTextToSpeech', this.speech);
      } else {
        this.$store.dispatch('setTextToSpeech', '');
      }
      this.onSpeech();
      this.textToSpeech = !this.textToSpeech;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
